import React from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../Utils/useReveal';
import styles from './Projects.module.css';

export default function ProjectCard({ project }) {
  const [ref, revealed] = useReveal();

  return (
    <li ref={ref} className={`${styles.card} mc-reveal`} data-revealed={revealed}>
      <Link to={project.route} className={styles.cardLink}>
        <div className={styles.media}>
          <img
            className={styles.cover}
            src={project.cover}
            alt=""
            loading="lazy"
            decoding="async"
            width={900}
            height={675}
          />
          <span className={styles.mediaScrim} aria-hidden="true" />
          <span className={styles.year}>{project.year}</span>
          {project.award && <span className={styles.award}>{project.award}</span>}

          {/* Corner brackets draw in on hover */}
          <span className={`${styles.bracket} ${styles.bracketTL}`} aria-hidden="true" />
          <span className={`${styles.bracket} ${styles.bracketBR}`} aria-hidden="true" />
        </div>

        <div className={styles.body}>
          {project.event && <p className={styles.event}>{project.event}</p>}
          <h3 className={styles.title}>{project.title}</h3>
          <p className={styles.blurb}>{project.blurb}</p>
          {project.stack?.length > 0 && (
            <ul className={styles.stack}>
              {project.stack.map((s) => (
                <li key={s} className="mc-chip">{s}</li>
              ))}
            </ul>
          )}
        </div>
      </Link>
    </li>
  );
}
